import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 69px 15px;
  gap: 35px;
`;

export const Text = styled(Typography.Body)`
  font-weight: 500;
  text-align: center;
`;
